// src/components/FeatureHero.js
import React from 'react';

const FeatureHero = ({ icon: Icon, title, subtitle, backgroundImage }) => {
  return (
    // ✅ Make the section full-screen and a flex container for vertical centering
    <section className="relative h-screen flex flex-col items-center justify-center text-center overflow-hidden">
      {backgroundImage && (
        <div className="hero-bg-image-container">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover animate-pan-zoom" />
        </div>
      )}

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[150%] h-[150%] bg-gradient-to-r from-dark-accent-start/20 via-dark-accent-end/20 to-transparent opacity-30 animate-aurora" style={{ backgroundSize: '400% 400%' }} />

      <div className="relative z-10 mx-auto max-w-4xl px-6">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end mb-6">
          <Icon className="h-8 w-8 text-white" />
        </div>
        <h1 className="text-4xl font-extrabold tracking-tight text-dark-text-primary sm:text-6xl">
          {title}
        </h1>
        <p className="mt-6 text-lg leading-8 text-dark-text-secondary">
          {subtitle}
        </p>
      </div>
    </section>
  );
};

export default FeatureHero;